import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { TabComponents } from '@ohif/ui';

// Tabs
import { HotkeysPreferences } from './HotkeysPreferences';
import { WindowLevelPreferences } from './WindowLevelPreferences';
import { GeneralPreferences } from './GeneralPreferences';
import { MarkPreferences } from './MarkPreferences';
import { useIsResearch } from '../../appExtensions/Mark/hook';

import './UserPreferences.styl';

const tabs = [
  {
    // name: 'Hotkeys',
    name: '阅片快捷键设置',
    Component: HotkeysPreferences,
    customProps: {},
  },
  {
    // name: 'General',
    name: '通用设置',
    Component: GeneralPreferences,
    customProps: {},
  },
  {
    // name: 'Window Level',
    name: '窗位设置',
    Component: WindowLevelPreferences,
    customProps: {},
  },
];

function UserPreferences({ hide }) {
  const isScience = useIsResearch();
  const tabData = useMemo(
    () =>
      isScience
        ? tabs.concat([
            {
              name: '标注快捷键设置',
              Component: MarkPreferences,
              customProps: {},
            },
          ])
        : tabs,
    [isScience]
  );

  const customProps = {
    onClose: hide,
  };
  return <TabComponents tabs={tabData} customProps={customProps} />;
}

UserPreferences.propTypes = {
  hide: PropTypes.func,
};

export { UserPreferences };
